export const exportHeaders = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },

    {
        label: "Redemption Date",
        key: "date_of_transaction"
    },


    {
        label: "Requested Redeemed Points",
        key: "points_redeemed"
    },

    {
        label: "Status",
        key: "transaction_status"
    },

    {
        label: "JDE Approval Status",
        key: "redemption_approval_status"
    },
    {
        label: "Cancelled By",
        key: "altered_by"
    },
    

    
]